import { MobileProjectCreatePage } from './MobileProjectCreatePage';
import { withMobileProjectCreatePage } from './withMobileProjectCreatePage';

const ConnectedMobileProjectCreatePage = withMobileProjectCreatePage(
  MobileProjectCreatePage
);

export { ConnectedMobileProjectCreatePage as MobileProjectCreatePage };
